module.exports = __webpack_public_path__ + "static/favicon-0522c5f22a0a96548c6870a4cde2ecba.png";